var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcon = function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13 .4C19.959.4 25.6 6.041 25.6 13S19.959 25.6 13 25.6.4 19.959.4 13 6.041.4 13 .4m0 1.51C6.875 1.91 1.91 6.875 1.91 13S6.875 24.09 13 24.09 24.09 19.125 24.09 13 19.125 1.91 13 1.91m.158 7.94c.427 0 .774.32.787.717v9.254c0 .408-.353.739-.787.739-.428 0-.775-.32-.788-.717v-9.254c0-.408.353-.739.788-.739m0-4.725a1.417 1.417 0 1 1 0 2.835 1.417 1.417 0 0 1 0-2.835"
  })));
};
export default SvgIcon;